export const METRIC = "metric";

export const IMPERIAL = "imperial";
